import { render } from "./MerchantProfileFormEdit.vue?vue&type=template&id=1c4855c6"
import script from "./MerchantProfileFormEdit.vue?vue&type=script&lang=js"
export * from "./MerchantProfileFormEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__